import { render } from "./module.vue?vue&type=template&id=b0ab06d4"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/projects-gallery/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0ab06d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0ab06d4', __exports__)) {
    api.reload('b0ab06d4', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=b0ab06d4", () => {
    api.rerender('b0ab06d4', render)
  })

}


export default __exports__